import '../../styles/frontend/background.css'

export function setFullWidthContainer() {
    var fullwidthElements = document.querySelectorAll('.dd-fullwidth');
    fullwidthElements.forEach(function (element) {
        element.closest('div[class^="col-"], div[class*=" col-"]').style.position = 'static'; // Chrome Fix
    });

    var containerWidth = (document.querySelector('.cmsContent .dd-ve-container')).clientWidth;
    var gap = Math.floor((document.body.clientWidth - containerWidth) / 2);

    fullwidthElements.forEach(function (element) {
        element.style.margin = '0 -' + gap + 'px';

        if (!element.querySelector('.dd-hero-box') && !hasAnyClass(element, ['dd-image-box', 'dd-image-gallery'])) {
            element.style.padding = '0 ' + gap + 'px';
        }
    });
}

export function hasAnyClass(element, classes) {
    return classes.some(className => element.classList.contains(className));
}

if (!document.querySelector('.dd-boxed-container')) {
    window.addEventListener('load', setFullWidthContainer);
    window.addEventListener('resize', setFullWidthContainer);
}